import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  return (
    <>
      <Modal
        title={`Nueva Cuota de Compra`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-compra-periodo'
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!cuota ? cuota.description : ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="cuota"
          margin="normal"
          defaultValue={!!cuota ? cuota.cuota : ''}
          onChange={(e) => handleChange('cuota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});

